/** A deal waiting on an answer (offered, or countered). */
export const isPending = (d) => d.status === 'offered' || d.status === 'countered';
/** Who answers the deal next: its partner an offer, its offerer a counter. */
export const dealResponder = (d) => (d.status === 'offered' ? d.to : d.from);
/**
 * Players `playerId` promised not to attack right now, from this round's `deals`: the partner of
 * a deal they accepted (the whole round), the partner of one they offered until the last pass
 * (`lastPass`: the round's last pass has begun) or for the whole round.
 */
export function sparedBy(deals, playerId, lastPass) {
    return deals.flatMap((d) => {
        if (d.status !== 'active')
            return [];
        if (d.to === playerId)
            return [d.from];
        if (d.from === playerId && (d.spare === 'round' || !lastPass))
            return [d.to];
        return [];
    });
}
//# sourceMappingURL=deals.js.map